<svg
  class="mandala-wheel"
  [class.is-dim-disabled]="isDimDisabled()"
  [attr.viewBox]="viewBox()"
  [attr.data-quarter-variant]="quarterColorVariant()"
  preserveAspectRatio="xMidYMid meet"
  role="img"
  aria-label="Human Design mandala-wiel"
>
  @if (quarterRingVisible()) {
    <g class="mandala-layer mandala-layer--quarters">
      @for (quarter of quarterViews(); track quarter.id) {
        <path class="mandala-quarter" [attr.data-quarter]="quarter.key" [attr.d]="quarter.pathD">
          @if (quarter.tooltip) {
            <title>{{ quarter.tooltip }}</title>
          }
        </path>
        <!-- Onzichtbare boog waarlangs de keynote met de band meebuigt. -->
        <path class="mandala-quarter__keynote-arc" [attr.id]="quarter.arcId" [attr.d]="quarter.arcD"></path>
        <!-- Tspans op één regel: witruimte tussen de delen zit ín de strings. -->
        <text class="mandala-quarter__label">
          <textPath
            [attr.href]="'#' + quarter.arcId"
            startOffset="50%"
            text-anchor="middle"
          ><tspan>{{ quarter.keynoteLead }}</tspan><tspan class="mandala-quarter__keynote-purpose">{{ quarter.keynotePurpose }}</tspan><tspan>{{ quarter.keynoteTail }}</tspan></textPath>
        </text>
      }
    </g>
  }

  @if (godheadRingVisible()) {
    <g class="mandala-layer mandala-layer--godheads">
      @for (godhead of godheadViews(); track godhead.id) {
        <path
          class="mandala-godhead"
          [attr.data-quarter]="godhead.quarterKey"
          [attr.d]="godhead.pathD"
        ></path>
        <!-- Onzichtbare boog waarlangs de naam met de band meebuigt. -->
        <path class="mandala-godhead__name-arc" [attr.id]="godhead.arcId" [attr.d]="godhead.arcD"></path>
        <text class="mandala-godhead__name">
          <textPath
            [attr.href]="'#' + godhead.arcId"
            startOffset="50%"
            text-anchor="middle"
          >{{ godhead.name }}</textPath>
        </text>
      }
    </g>
  }

  @if (zodiacRingVisible()) {
    <g class="mandala-layer mandala-layer--zodiac" [class.mandala-layer--zodiac-light]="zodiacRingVariant() === 'light'">
      @for (sign of zodiacViews(); track sign.id) {
        <!-- Native tooltip met de (gelokaliseerde) tekennaam; de glyph is
             pointer-inert dus de band zelf draagt de title. -->
        <path class="mandala-zodiac" [attr.d]="sign.pathD">
          <title>{{ sign.name }}</title>
        </path>
        <text
          class="mandala-zodiac__glyph"
          [attr.x]="sign.glyphX"
          [attr.y]="sign.glyphY"
          text-anchor="middle"
          dominant-baseline="central"
        >{{ sign.glyph }}</text>
      }
    </g>
  }

  @if (ichingRingVisible()) {
    <g class="mandala-layer mandala-layer--iching">
      @for (symbol of ichingViews(); track symbol.id) {
        <text
          class="mandala-iching__glyph"
          [class.is-highlighted]="isGateHighlighted(symbol.gate)"
          [class.is-dimmed]="isDimActive() && !isGateHighlighted(symbol.gate)"
          [attr.x]="symbol.glyphX"
          [attr.y]="symbol.glyphY"
          text-anchor="middle"
          dominant-baseline="central"
        >{{ symbol.glyph }}</text>
      }
    </g>
  }

  <g class="mandala-layer mandala-layer--gates">
    @for (gate of gateViews(); track gate.id) {
      <path
        class="mandala-gate"
        [class.is-active]="gate.isActive"
        [class.is-highlighted]="isGateHighlighted(gate.gate)"
        [class.is-dimmed]="isDimActive() && !isGateHighlighted(gate.gate)"
        [attr.d]="gate.pathD"
        [attr.fill]="gate.fill"
        [attr.data-gate]="gate.gate"
        (mouseenter)="onGateEnter(gate.gate)"
        (mouseleave)="onGateLeave()"
        (click)="onGateClick(gate.gate, $event)"
        (contextmenu)="onGateContextMenu(gate.gate, $event)"
      ></path>
    }
  </g>

  <g class="mandala-layer mandala-layer--lines">
    @for (line of lineViews(); track line.id) {
      <path
        class="mandala-line"
        [class.is-active]="line.isActive"
        [class.is-line-hovered]="isLineHovered(line.id)"
        [class.is-dimmed]="isDimActive() && !isGateHighlighted(line.gate)"
        [attr.d]="line.pathD"
        [attr.data-gate]="line.gate"
        [attr.data-line]="line.line"
        (mouseenter)="onLineEnter(line)"
        (mouseleave)="onLineLeave()"
        (click)="onGateClick(line.gate, $event)"
        (contextmenu)="onGateContextMenu(line.gate, $event)"
      ></path>
    }
  </g>

  <!-- "Dimmen bij hover" uit: de blauwe rand van gehighlighte poortblokjes
       als aparte laag BOVEN de poorten- en lijnen-ring. Een stroke op het
       slice-element zelf wordt half overtekend door buurslices en de
       lijnen-ring (latere SVG-siblings), waardoor de rand amper zichtbaar
       was (Stevens check 2026-10-01, poorten 9/58). -->
  @if (isDimDisabled()) {
    <g class="mandala-layer mandala-layer--gate-outlines">
      @for (gate of gateViews(); track gate.id) {
        @if (isGateHighlighted(gate.gate)) {
          <path class="mandala-gate-outline" [attr.d]="gate.pathD"></path>
        }
      }
    </g>
  }

  <g class="mandala-layer mandala-layer--labels">
    @for (gate of gateViews(); track gate.id) {
      <text
        class="mandala-gate__number"
        [class.is-active]="gate.isActive"
        [style.fill]="isDimActive() && !isGateHighlighted(gate.gate) ? null : gate.labelFill"
        [attr.x]="gate.labelX"
        [attr.y]="gate.labelY"
        text-anchor="middle"
        dominant-baseline="central"
      >{{ gate.gate }}</text>
    }
  </g>

  <circle
    class="mandala-center-disc"
    [attr.cx]="center().x"
    [attr.cy]="center().y"
    [attr.r]="innerWheelRadius()"
  ></circle>

  <!-- Activatie-zone: pizza-slices per poort tussen de wielrand en de
       zone-rand. NA de center-disc (de dekkende schijf zou ze anders
       bedekken); de chart-laag van de pagina ligt er weer bovenop. -->
  <g class="mandala-layer mandala-layer--slices">
    <!-- Optionele gefadede centerkleur per geactiveerde slice, vóór de
         spaken/rand zodat die er leesbaar overheen blijven liggen. -->
    @for (fill of sliceCenterFillViews(); track fill.id) {
      <path class="mandala-slice__center-fill" [attr.d]="fill.pathD" [attr.fill]="fill.fill" [style.opacity]="fill.opacity"></path>
    }
    <circle
      class="mandala-slice__rim"
      [attr.cx]="center().x"
      [attr.cy]="center().y"
      [attr.r]="sliceInnerRadius()"
    ></circle>
    @for (slice of sliceViews(); track slice.id) {
      <path class="mandala-slice__spoke" [attr.d]="slice.pathD"></path>
    }
  </g>

  <!-- Planeetactivatie-glyphs: per poort gestapeld in zijn slice, kleuren
       bron-gebonden (opgelost door de page). Boven de slices, onder de
       transit-lagen; de chart-laag van de pagina ligt erbovenop. -->
  @if (glyphViews().length > 0) {
    <g class="mandala-layer mandala-layer--activation-glyphs">
      @for (glyph of glyphViews(); track glyph.key) {
        <text
          class="mandala-activation-glyph"
          [class.is-dimmed]="isDimActive() && !isGateHighlighted(glyph.gate)"
          [attr.x]="glyph.x"
          [attr.y]="glyph.y"
          [attr.fill]="glyph.color"
          text-anchor="middle"
          dominant-baseline="central"
        >{{ glyph.glyph }}</text>
      }
    </g>
  }

  <!-- Maan-transit laag (spec 2026-07-06 §6.2): bewust NA de center-disc zodat
       de connectors over de witte schijf heen zichtbaar blijven. -->
  @if (moonTransit()) {
    <g class="mandala-layer mandala-layer--moon-transit">
      @for (connector of moonConnectorViews(); track connector.id) {
        <path
          class="mandala-moon-connector"
          [class.is-highlighted]="moonTransitHighlightedKeys().has(connector.channelKey)"
          [attr.d]="connector.pathD"
        ></path>
        <circle
          class="mandala-moon-connector-end"
          [attr.cx]="connector.endX"
          [attr.cy]="connector.endY"
          r="4"
        ></circle>
        <!-- Brede onzichtbare hit-laag: hover koppelt lijn ↔ card, klik opent kanaal-info. -->
        <path
          class="mandala-moon-connector-hit"
          [attr.d]="connector.pathD"
          (mouseenter)="moonTransitConnectorHovered.emit(connector.formation)"
          (mouseleave)="moonTransitConnectorHovered.emit(null)"
          (click)="onMoonConnectorClick(connector.formation, $event)"
        ></path>
      }
      @for (marker of moonGateMarkerViews(); track marker.id) {
        @switch (marker.kind) {
          @case ('ring') {
            <circle
              class="mandala-moon-ring"
              [attr.cx]="marker.cx"
              [attr.cy]="marker.cy"
              [attr.r]="marker.r"
            ></circle>
          }
          @case ('frame') {
            <path class="mandala-moon-frame" [attr.d]="marker.pathD"></path>
          }
        }
      }
      @if (todayMarkerView(); as today) {
        <g class="mandala-moon-today">
          @if (today.tooltip) {
            <title>{{ today.tooltip }}</title>
          }
          <line
            class="mandala-moon-today__needle"
            [attr.x1]="today.x1"
            [attr.y1]="today.y1"
            [attr.x2]="today.x2"
            [attr.y2]="today.y2"
          ></line>
          <text
            class="mandala-moon-today__icon"
            [attr.x]="today.iconX"
            [attr.y]="today.iconY"
            text-anchor="middle"
            dominant-baseline="central"
          >{{ today.glyph }}</text>
        </g>
      }
    </g>
  }
  @if (justNowTransit()) {
    <g class="mandala-layer mandala-layer--just-now-transit">
      @for (connector of justNowConnectorViews(); track connector.id) {
        <path
          class="mandala-just-now-connector"
          [class.is-highlighted]="justNowTransitHighlightedKeys().has(connector.channelKey)"
          [attr.d]="connector.pathD"
        ></path>
        <circle
          class="mandala-just-now-connector-end"
          [attr.cx]="connector.endX"
          [attr.cy]="connector.endY"
          r="4"
        ></circle>
        <path
          class="mandala-just-now-connector-hit"
          [attr.d]="connector.pathD"
          (mouseenter)="justNowTransitConnectorHovered.emit(connector.formation)"
          (mouseleave)="justNowTransitConnectorHovered.emit(null)"
          (click)="onJustNowConnectorClick(connector.formation, $event)"
        ></path>
      }
      @for (marker of justNowGateMarkerViews(); track marker.id) {
        <circle
          class="mandala-just-now-ring"
          [attr.cx]="marker.cx"
          [attr.cy]="marker.cy"
          [attr.r]="marker.r"
        ></circle>
      }
    </g>
  }

  <!-- Poort-patronen-overlay (Mandala-tab): kanaal-links (blauw), partner-links
       (rood, diameters) en het incarnatiekruis. Onder de Locks & Keys-laag. -->
  @if (patterns()) {
    <g class="mandala-layer mandala-layer--patterns">
      @for (connector of patternChannelConnectorViews(); track connector.id) {
        <path
          class="mandala-pattern-channel"
          [class.is-highlighted]="isPatternConnectorHighlighted(connector)"
          [attr.d]="connector.pathD"
        ></path>
      }
      @for (connector of patternPartnerConnectorViews(); track connector.id) {
        <path
          class="mandala-pattern-partner"
          [class.is-highlighted]="isPatternConnectorHighlighted(connector)"
          [attr.d]="connector.pathD"
        ></path>
      }
      @for (connector of patternCrossConnectorViews(); track connector.id) {
        <path
          class="mandala-pattern-cross"
          [class.is-highlighted]="isPatternConnectorHighlighted(connector)"
          [attr.d]="connector.pathD"
        ></path>
      }
      @for (marker of patternCrossGateMarkerViews(); track marker.id) {
        <circle class="mandala-pattern-cross-marker" [attr.cx]="marker.cx" [attr.cy]="marker.cy" [attr.r]="marker.r"></circle>
      }
      @for (connector of patternLifeCrossConnectorViews(); track connector.id) {
        <path
          class="mandala-pattern-life-cross"
          [class.is-highlighted]="isPatternConnectorHighlighted(connector)"
          [attr.d]="connector.pathD"
        ></path>
      }
      @for (marker of patternLifeCrossGateMarkerViews(); track marker.id) {
        <circle class="mandala-pattern-life-cross-marker" [attr.cx]="marker.cx" [attr.cy]="marker.cy" [attr.r]="marker.r"></circle>
      }
    </g>
  }

  <!-- Locks & Keys-laag (spec 2026-08-27): gele lock-vensters met wig,
       dusk-blauwe key-markers en verbindingslijnen key → lock. NA de andere
       lagen zodat de vensters en iconen bovenop liggen. -->
  @if (locksKeys()) {
    <g class="mandala-layer mandala-layer--locks-keys">
      <!-- 8-puntige ster: wig-tot-wig vierkanten per incarnatiekruis, onder de
           bogen en vensters zodat de structuur de details niet overtekent. -->
      @for (star of locksKeysStarViews(); track star.id) {
        <path
          [class]="'mandala-locks-keys-star mandala-locks-keys-star--' + star.kind"
          [attr.d]="star.pathD"
        ></path>
      }
      <!-- Rode wijzer van het lentepunt: de precessie zelf, zichtbaar zodra een ster aan staat. -->
      @if (locksKeysEquinoxPointerView(); as equinox) {
        <g class="mandala-locks-keys-equinox">
          <line [attr.x1]="equinox.x1" [attr.y1]="equinox.y1" [attr.x2]="equinox.x2" [attr.y2]="equinox.y2"></line>
          <circle [attr.cx]="equinox.x1" [attr.cy]="equinox.y1" r="4"></circle>
          <circle [attr.cx]="equinox.x2" [attr.cy]="equinox.y2" r="4.5"></circle>
        </g>
      }
      @for (connector of locksKeysConnectorViews(); track connector.id) {
        <path class="mandala-locks-keys-connector" [attr.d]="connector.pathD"></path>
      }
      @for (marker of locksKeysKeyMarkerViews(); track marker.id) {
        @if (marker.framePathD) {
          <path class="mandala-locks-keys-key-frame" [attr.d]="marker.framePathD"></path>
        }
        @if (marker.pointerPathD) {
          <path
            class="mandala-locks-keys-key-pointer"
            [class.is-inactive]="!marker.activated"
            [attr.d]="marker.pointerPathD"
          ></path>
        }
        <text
          class="mandala-locks-keys-key-icon"
          [class.is-inactive]="!marker.activated"
          [attr.x]="marker.iconX"
          [attr.y]="marker.iconY"
          text-anchor="middle"
          dominant-baseline="central"
          (click)="onLocksKeysMarkerClick(marker.lockGate, $event)"
        >{{ keyGlyph }}</text>
      }
      @for (marker of locksKeysLockMarkerViews(); track marker.id) {
        <!-- Donkere gouden onderrand + G-geel venster erbovenop: leesbaar op
             zowel de lichte wielband als geactiveerde poortkleuren. -->
        <path class="mandala-locks-keys-lock-frame-outline" [attr.d]="marker.framePathD"></path>
        <path
          class="mandala-locks-keys-lock-frame"
          [attr.d]="marker.framePathD"
          (click)="onLocksKeysMarkerClick(marker.gate, $event)"
        ></path>
        <path class="mandala-locks-keys-lock-pointer" [attr.d]="marker.pointerPathD"></path>
        <text
          class="mandala-locks-keys-lock-icon"
          [attr.x]="marker.iconX"
          [attr.y]="marker.iconY"
          text-anchor="middle"
          dominant-baseline="central"
          (click)="onLocksKeysMarkerClick(marker.gate, $event)"
        >{{ lockGlyph }}</text>
      }
      <!-- Keynote (rol) als cirkeltekst boven elk slotje, buiten de wielrand. -->
      @for (keynote of locksKeysKeynoteViews(); track keynote.id) {
        <path class="mandala-locks-keys-keynote-arc" [attr.id]="keynote.arcId" [attr.d]="keynote.arcD"></path>
        <text class="mandala-locks-keys-keynote">
          <textPath [attr.href]="'#' + keynote.arcId" startOffset="50%" text-anchor="middle">{{ keynote.text }}</textPath>
        </text>
      }
    </g>
  }
  @if (seasonMarkerViews(); as seasons) {
    @if (seasons.length > 0) {
      <!-- Zonnewendes en equinoxen: cardinale lengtes in lijn 2 van de Vessel of Love-poorten, als speld op de band. -->
      <g class="mandala-layer mandala-layer--seasons">
        @for (season of seasons; track season.id) {
          <g class="mandala-season" [attr.data-season]="season.key">
            @if (season.tooltip) {
              <title>{{ season.tooltip }}</title>
            }
            <circle
              class="mandala-season__badge"
              [attr.cx]="season.cx"
              [attr.cy]="season.cy"
              [attr.r]="season.r"
            ></circle>
            <circle
              class="mandala-season__sun-ring"
              [attr.cx]="season.cx"
              [attr.cy]="season.cy"
              [attr.r]="seasonSunRingRadius"
            ></circle>
            <circle
              class="mandala-season__sun-dot"
              [attr.cx]="season.cx"
              [attr.cy]="season.cy"
              [attr.r]="seasonSunDotRadius"
            ></circle>
          </g>
        }
      </g>
    }
  }
</svg>
